var footerParentAccordion = document.querySelectorAll("[data-parent-accordion]");
var footerChildsAccordion = "[data-childs-accordion]";

footerParentAccordion.forEach((parent) => {
    parent.addEventListener("click", (event) => {
        var child = event.target.querySelector(footerChildsAccordion);
        if (child != undefined && child.offsetHeight == 0) {
            child.style.maxHeight = "300px";
        } else if (child != undefined) {
            child.style.maxHeight = "0px";
        }
    })
})